import {User} from '../@types';
import {UnitLink} from '../@types/UnitLink';

export const deriveDisplayName = (user: User) => {
  if (!user || typeof user !== 'object') {
    return 'Not provided';
  }

  const firstName = user.firstName != null ? user.firstName : '';
  const lastName = user.lastName != null ? user.lastName : '';

  const displayName = `${firstName} ${lastName}`;
  return displayName.length > 1 ? displayName : 'Not provided';
};

export function deriveUnitName(unitLink: UnitLink) {
  if (!unitLink || !unitLink.unit) {
    return '';
  }
  const name = unitLink.unit.unitDisplay || unitLink.unit.unitName || '';
  return name;
}
